var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "p28aiinrqa",
    d: "M0.065 0.569L10.813 0.569 10.813 8.1 0.065 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58g6mltyac",
    d: "M0 0.029L18.078 0.029 18.078 4.169 0 4.169z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wtsbun9sme",
    d: "M0.064 0.502L10.813 0.502 10.813 14.429 0.064 14.429z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 18.398)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9gzt0ex6fb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p28aiinrqa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M8.364.57c.538.633.862 1.443.862 2.325 0 2.022-1.7 3.667-3.787 3.667-2.088 0-3.787-1.645-3.787-3.667 0-.882.324-1.692.862-2.326H.634c-.364.7-.57 1.49-.57 2.326C.065 5.765 2.476 8.1 5.44 8.1c2.963 0 5.374-2.335 5.374-5.204 0-.837-.206-1.627-.57-2.327h-1.88z",
    mask: "url(#9gzt0ex6fb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.798)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7b0cbcn3ed",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58g6mltyac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB7C",
    d: "M15.94.03H2.138C.84.03 0 .841 0 2.1c0 1.257.839 2.07 2.137 2.07h13.804c1.298 0 2.137-.813 2.137-2.07 0-1.258-.839-2.07-2.137-2.07",
    mask: "url(#7b0cbcn3ed)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 .398)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i5hnwb1hzf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wtsbun9sme"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M2.323 14.43h6.232c-.154-4.593 2.258-5.84 2.258-8.738 0-2.944-2.455-5.19-5.374-5.19C2.52.502.064 2.748.064 5.692c0 2.898 2.413 4.145 2.259 8.737",
    mask: "url(#i5hnwb1hzf)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfancy);
export default __webpack_public_path__ + "static/media/infancy.ca14f81753bd80ab49acd227905017ab.svg";
export { ForwardRef as ReactComponent };